import classNames from 'classnames'
import { ReactNode } from 'react'
import { HEADER_DEFAULT_PADDING_STYLES } from './Header'

export const LAYOUT_PADDING_TOP_DEFAULT = 'pt-[100px] md:pt-[130px] lg:pt-[140px] xl:pt-[160px] pb-[40px] md:pb-[20px]'

interface IProps {
  id?: string
  classes?: string
  innerClasses?: string
  containerTopPadding?: string
  topPadding?: string
  children: ReactNode
}

export const LayoutPadding = ({ id, classes, innerClasses, containerTopPadding, topPadding, children }: IProps) => (
  <div id={id} className={classNames(containerTopPadding, LAYOUT_PADDING_TOP_DEFAULT)}>
    <div className={classNames(classes, topPadding, HEADER_DEFAULT_PADDING_STYLES, 'pb-[50px] md:pb-[40px]')}>
      <div className={classNames(innerClasses)}>{children}</div>
    </div>
  </div>
)
